/* BCB product detail. Gallery, variant matching, sticky ATC, recommendations. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function parseJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-bcb-gallery]');
    if (!gallery) return;

    var track = gallery.querySelector('[data-bcb-gallery-track]');
    var slides = gallery.querySelectorAll('[data-bcb-slide]');
    var dots = gallery.querySelectorAll('[data-bcb-dot]');
    var thumbs = gallery.querySelectorAll('[data-bcb-thumb]');
    if (!track || !slides.length) return;

    function setCurrent(index) {
      slides.forEach(function (slide, i) {
        slide.toggleAttribute('data-active', i === index);
      });
      dots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      thumbs.forEach(function (thumb, i) {
        if (i === index) {
          thumb.setAttribute('aria-current', 'true');
          if (typeof thumb.scrollIntoView === 'function') {
            thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setCurrent(index);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var index = Number(entry.target.getAttribute('data-bcb-slide'));
            if (!Number.isNaN(index)) setCurrent(index);
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (slide) {
        io.observe(slide);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.getAttribute('data-bcb-dot')));
      });
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(Number(thumb.getAttribute('data-bcb-thumb')));
      });
    });

    var canZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canZoom) {
      gallery.querySelectorAll('[data-bcb-zoom]').forEach(function (slide) {
        slide.addEventListener('mousemove', function (event) {
          var rect = slide.getBoundingClientRect();
          var x = ((event.clientX - rect.left) / rect.width) * 100;
          var y = ((event.clientY - rect.top) / rect.height) * 100;
          slide.style.setProperty('--bcb-zoom-x', x + '%');
          slide.style.setProperty('--bcb-zoom-y', y + '%');
        });
      });
    }

    gallery._bcbGoToMedia = function (mediaId) {
      if (!mediaId) return;
      var match = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (!match) return;
      goTo(Number(match.getAttribute('data-bcb-slide')));
    };
  }

  function findVariant(variants, options) {
    return variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === options[index];
      });
    });
  }

  function initForm(root) {
    var form = root.querySelector('[data-bcb-pdp-form]');
    var stateEl = root.querySelector('[data-bcb-pdp-state]');
    var state = parseJson(stateEl);
    if (!form || !state) return;

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-bcb-qty]');
    var priceNow = root.querySelector('[data-bcb-price-now]');
    var priceWas = root.querySelector('[data-bcb-price-was]');
    var priceReg = root.querySelector('[data-bcb-price-reg]');
    var priceWrap = root.querySelector('[data-bcb-price]');
    var saleChip = root.querySelector('[data-bcb-sale-chip]');
    var saveEl = root.querySelector('[data-bcb-save]');
    var atc = form.querySelector('[data-add-to-cart]');
    var atcText = form.querySelector('[data-add-to-cart-text]');
    var errorEl = form.querySelector('[data-bcb-form-error]');
    var gallery = root.querySelector('[data-bcb-gallery]');
    // Kargo seçeneği formun dışında, Growth Suite bloğunun üstünde çizilir (sıra 18): gruplar bölümden okunur.
    var optionGroups = root.querySelectorAll('[data-bcb-option-group]');

    function selectedOptions() {
      var values = [];
      optionGroups.forEach(function (group) {
        if (group.matches('select')) {
          values.push(group.value);
          return;
        }
        var checked = group.querySelector('input:checked');
        values.push(checked ? checked.value : '');
      });
      return values;
    }

    function currentVariant() {
      if (optionGroups.length) {
        return findVariant(state.variants, selectedOptions());
      }
      var id = idInput ? Number(idInput.value) : null;
      return state.variants.find(function (variant) {
        return variant.id === id;
      }) || state.variants[0];
    }

    function applyVariant(variant) {
      if (!variant) {
        if (atc) {
          atc.disabled = true;
          if (atcText) atcText.textContent = atc.getAttribute('data-unavailable') || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      // Growth Suite and shared links read the selected variant from the URL.
      try {
        var variantParam = 'variant=' + encodeURIComponent(String(variant.id));
        var parts = window.location.search ? window.location.search.slice(1).split('&') : [];
        var urlVariantParam = parts.find(function (part) {
          return part.split('=')[0] === 'variant';
        });
        if (/\/products\/[^/]+/.test(window.location.pathname) && urlVariantParam !== variantParam) {
          // Preserve attribution parameters exactly as they appeared in the URL.
          parts = parts.filter(function (part) {
            return part && part.split('=')[0] !== 'variant';
          });
          parts.push(variantParam);
          window.history.replaceState(window.history.state, '', window.location.pathname + '?' + parts.join('&') + window.location.hash);
        }
      } catch (e) {}
      var displayPrice = variant.price;
      var displayCompare = variant.compare;
      var displaySave = variant.save;
      var displaySaveMoney = variant.saveMoney;
      if (priceNow) priceNow.textContent = displayPrice;
      if (priceWrap) priceWrap.classList.toggle('bcb-pdp__price--sale', Boolean(displayCompare));
      if (saleChip) saleChip.hidden = !variant.saleBadge;
      if (priceReg) priceReg.hidden = !displayCompare;
      if (priceWas) {
        priceWas.textContent = displayCompare || '';
      }
      if (saveEl) {
        if (displayCompare && variant.saleBadge) {
          var saveBits = [];
          if (displaySaveMoney) saveBits.push('Save ' + displaySaveMoney);
          if (displaySave) saveBits.push(displaySave + '%');
          saveEl.hidden = saveBits.length === 0;
          saveEl.textContent = saveBits.join(' · ');
        } else {
          saveEl.hidden = true;
          saveEl.textContent = '';
        }
      }
      if (atc) {
        atc.disabled = !variant.available;
        if (atcText) {
          atcText.textContent = variant.available
            ? atc.getAttribute('data-add') || 'Add to cart'
            : atc.getAttribute('data-soldout') || 'Sold out';
        }
      }
      if (gallery && gallery._bcbGoToMedia) gallery._bcbGoToMedia(variant.mediaId);

      var stickyNow = document.querySelector('[data-bcb-sticky-now]');
      var stickyWas = document.querySelector('[data-bcb-sticky-was]');
      var stickyBtn = document.querySelector('[data-bcb-sticky-btn]');
      if (stickyNow) {
        stickyNow.textContent = displayPrice;
        stickyNow.classList.toggle('is-sale', Boolean(displayCompare));
      }
      if (stickyWas) {
        if (displayCompare) {
          stickyWas.textContent = displayCompare;
          stickyWas.hidden = false;
        } else {
          stickyWas.hidden = true;
        }
      }
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available
          ? stickyBtn.getAttribute('data-add') || 'Add to cart'
          : stickyBtn.getAttribute('data-soldout') || 'Sold out';
      }
    }

    // Growth Suite kademe satırları seçili varyantı kendisi izliyor; tema eşlemesi (syncGrowthSuite) 29 Eki 2026'da kaldırıldı.
    // Sınama: pill, 8'den fazla değerli select, renk swatch'ı, kademe 1-3, iki seçim sırası; /cart.js variant_id ve adet tuttu.

    optionGroups.forEach(function (group) {
      group.addEventListener('change', function () {
        var fieldset = group.closest('.bcb-pdp-opt');
        var valueEl = fieldset && fieldset.querySelector('[data-bcb-opt-value]');
        if (valueEl) {
          if (group.matches('select')) {
            valueEl.textContent = group.value;
          } else {
            var checked = group.querySelector('input:checked');
            if (checked) valueEl.textContent = checked.value;
          }
        }
        applyVariant(currentVariant());
      });
    });

    // Tükenen kargo değeri aria-disabled: odaklanır ve okunur ama seçilmez (tıklama ve ok tuşu click üretir).
    root.querySelectorAll('[data-bcb-option-group] input[aria-disabled="true"]').forEach(function (input) {
      input.addEventListener('click', function (event) { event.preventDefault(); });
    });

    // Growth Suite kademe satırındaki kargo seçimi tema seçicisine yansır; yoksa altındaki teslim satırı eski değeri anlatır.
    var shipGroup = root.querySelector('[data-testid="bcb-pdp-shipping"] [data-bcb-option-group]');
    if (shipGroup) {
      document.addEventListener('change', function (event) {
        var select = event.target;
        if (!select.matches || !select.matches('.gs-vd-widget select')) return;
        var radio = Array.prototype.find.call(shipGroup.querySelectorAll('input'), function (input) { return input.value === select.value; });
        if (!radio || radio.checked) return;
        radio.checked = true;
        shipGroup.dispatchEvent(new Event('change', { bubbles: true }));
      }, true); // yakalama evresi: GS kendi select'inde yayılımı durdurabiliyor
    }

    form.querySelectorAll('[data-bcb-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var next = Number(qtyInput.value || 1) + Number(btn.getAttribute('data-bcb-qty-btn'));
        qtyInput.value = String(Math.max(1, next));
      });
    });

    form.addEventListener('submit', function () {
      if (errorEl) errorEl.textContent = '';
    });
  }

  function initSticky(root) {
    var bar = document.querySelector('[data-bcb-sticky]');
    var atc = root.querySelector('[data-add-to-cart]');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    if (!window.matchMedia('(max-width: 899px)').matches) return;

    function liveAddButton() {
      return document.querySelector('.gs-vd-add-btn') || atc;
    }

    var btn = bar.querySelector('[data-bcb-sticky-btn]');
    if (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        liveAddButton().click();
      });
    }

    function smileNodes() {
      return document.querySelectorAll(
        '#smile-ui-container, #smile-ui-lite-launcher, [id^="smile-ui"], iframe[id*="smile"], [class*="smile-launcher"], [class*="SmileLauncher"]'
      );
    }

    function setSticky(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.classList.toggle('bcb-pdp-sticky-on', on);
      var h = on ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--bcb-sticky-h', h + 'px');
      Array.prototype.forEach.call(smileNodes(), function (el) {
        if (on) {
          el.style.setProperty('bottom', h + 12 + 'px', 'important');
        } else {
          el.style.removeProperty('bottom');
        }
      });
    }

    var sentinel = document.getElementById('gs-volume-discount') || atc;
    var io = new IntersectionObserver(
      function (entries) {
        setSticky(!entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    io.observe(sentinel);

    var smileWatch = new MutationObserver(function () {
      if (!smileNodes().length) return;
      smileWatch.disconnect();
      if (document.documentElement.classList.contains('bcb-pdp-sticky-on')) {
        setSticky(true);
      }
    });
    smileWatch.observe(document.body, { childList: true, subtree: true });
  }

  function initDetailsClamp(root) {
    root.querySelectorAll('[data-bcb-details]').forEach(function (block) {
      var clip = block.querySelector('.bcb-pdp-acc__clip');
      var body = block.querySelector('.bcb-pdp-acc__body');
      var more = block.querySelector('[data-bcb-details-more]');
      if (!clip || !body || !more) return;

      function measure() {
        var needs = body.scrollHeight > 120 + 8;
        block.classList.toggle('is-short', !needs);
        more.hidden = !needs;
        if (!needs) block.classList.remove('is-open');
      }

      more.addEventListener('click', function () {
        var open = block.classList.toggle('is-open');
        more.textContent = open ? 'Read less' : 'Read more';
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      more.setAttribute('aria-expanded', 'false');
      measure();
    });
  }

  function initRecs() {
    document.querySelectorAll('[data-bcb-recs]').forEach(function (el) {
      if (el.getAttribute('data-bcb-recs-ready') === 'true') return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-bcb-recs]');
          if (incoming && incoming.innerHTML.trim()) {
            el.replaceWith(incoming);
          } else {
            var parent = el.parentElement;
            el.remove();
            if (parent && parent.classList.contains('bcb-pdp-recs') && !parent.textContent.trim()) {
              parent.remove();
            }
          }
        })
        .catch(function () {
          el.remove();
        });
    });
  }

  function initGsBestScroll() {
    var list = document.getElementById('gs_best_products_list');
    var prev = document.querySelector('.gs_best_product_header_arrow_left');
    var next = document.querySelector('.gs_best_product_header_arrow_right');
    if (!list || !prev || !next || list.dataset.bcbBound === '1') return;
    if (!list.querySelector('.gs_best_product_product_cart')) return;

    list.dataset.bcbBound = '1';

    function step() {
      var card = list.querySelector('.gs_best_product_product_cart');
      var gap = parseFloat(window.getComputedStyle(list).gap) || 16;
      return card ? card.getBoundingClientRect().width + gap : list.clientWidth * 0.8;
    }

    var prev2 = prev.cloneNode(true);
    var next2 = next.cloneNode(true);
    prev.parentNode.replaceChild(prev2, prev);
    next.parentNode.replaceChild(next2, next);
    prev2.addEventListener('click', function () {
      list.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next2.addEventListener('click', function () {
      list.scrollBy({ left: step(), behavior: 'smooth' });
    });
  }

  function initPolicies(root) {
    var box = root.querySelector('[data-bcb-policies]');
    if (!box) return;
    var tabs = Array.prototype.slice.call(box.querySelectorAll('[data-bcb-pol-tab]'));
    var panels = Array.prototype.slice.call(box.querySelectorAll('[data-bcb-pol-panel]'));
    if (!tabs.length) return;

    function select(id, focusTab) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-bcb-pol-tab') === id;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on && focusTab) tab.focus();
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-bcb-pol-panel') === id;
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab.getAttribute('data-bcb-pol-tab'), false);
      });
      tab.addEventListener('keydown', function (event) {
        var i = tabs.indexOf(tab);
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          var next = event.key === 'ArrowRight'
            ? tabs[(i + 1) % tabs.length]
            : tabs[(i - 1 + tabs.length) % tabs.length];
          select(next.getAttribute('data-bcb-pol-tab'), true);
        } else if (event.key === 'Home') {
          event.preventDefault();
          select(tabs[0].getAttribute('data-bcb-pol-tab'), true);
        } else if (event.key === 'End') {
          event.preventDefault();
          select(tabs[tabs.length - 1].getAttribute('data-bcb-pol-tab'), true);
        }
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-bcb-pdp]').forEach(function (root) {
      initGallery(root);
      initForm(root);
      initSticky(root);
      initDetailsClamp(root);
      initPolicies(root);
    });
    initRecs();

    var gsWrap = document.getElementById('gs_best_product_wrapper');
    if (gsWrap) {
      var gsObs = new MutationObserver(function () {
        window.setTimeout(initGsBestScroll, 40);
      });
      gsObs.observe(gsWrap, { childList: true, subtree: true });
      initGsBestScroll();
    }
  });
})();
